<template>
  <div class="meet-outer-spacer">
    <div class="flip-card">
      <div class="meet-team-card">
        <div class="person-image-box">
          <img :src="image" height="116" :alt="name" loading="lazy">
        </div>
        <div class="person-data-box">
          <div :class="[isOrange ? 'back-orange' : 'back-blue', 'back']"></div>
          <div class="front container py-5">
            <div class="header">
              <h4 class="name">
                {{ name }}
              </h4>
              <div class="position">
                {{ position }}
              </div>
            </div>
            <div class="body">
              {{ trimmedBody }}
            </div>
          </div>
        </div>
      </div>
      <div class="meet-team-card-back">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeetTeamCard',
  props: ['name', 'position', 'body', 'description', 'image', 'isOrange'],
  computed: {
    trimmedBody: function () {
      let body = this.body;
      // if (body.length > 31) {
      //   body = body.split(' ').slice(0, 6).join(' ');
      //   body = `"${body}"...`
      // }
      return body;
    }
  }
}
</script>

<style scoped>
  .meet-team-card {
    width: 250px;
    height: 373px;
    border-radius: 8px;
    position: relative;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
  .meet-team-card-back {
    width: 250px;
    height: 373px;
    background-color: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
    border-radius: 8px;

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 0.7rem;
  }

  /* making space between the cards and the navigation dots of the carousel */
  @media screen and (max-width: 576px) {
    .meet-outer-spacer {
      height: 450px;
    }
  }
  /* ---- */

  .flip-card {
    height: 373px;
    position: relative;
  }
  .flip-card > .meet-team-card, .flip-card > .meet-team-card-back {
    position: absolute;
    top: 0;
  }

  .flip-card > .meet-team-card-back {
    transform: rotateY(180deg);
  }

  .flip-card > .meet-team-card, .flip-card > .meet-team-card-back {
    transition: transform 0.6s;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .flip-card:hover > .meet-team-card {
    transform: rotateY(180deg);
  }
  .flip-card:hover > .meet-team-card-back {
    transform: rotateY(0deg);
  }
  @media screen and (max-width: 576px) {
    .meet-team-card {
      width: 200px !important;
    }
    .meet-team-card-back {
      width: 200px !important;
    }
  }

  .meet-team-card > .person-image-box {
    position: absolute;
    z-index: 2;

    height: 116px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .meet-team-card > .person-image-box > img {
    height: 116px;
    width: 116px;
    border-radius: 1000px;
  }

  .meet-team-card > .person-data-box > .back {
    height: 313px;
    width: 100%;
    border-radius: 8px;
    
    position: absolute;
    z-index: 0;

    bottom: 0;
  }
  .meet-team-card > .person-data-box > .back-orange {
    background-color: #F36F2E;
  }
  .meet-team-card > .person-data-box > .back-blue {
    background-color: #2881C3;
  }

  .meet-team-card > .person-data-box > .front {
    height: 305px;
    width: 100%;
    border-radius: 8px;

    position: absolute;
    z-index: 1;

    bottom: 0;
    background-color: #FDFEFF;

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }

  .meet-team-card > .person-data-box > .front > .header > .name {
    font-weight: 600 !important;
    font-size: 24px !important;
    color: #F36F2E !important;
  }
  
  .meet-team-card > .person-data-box > .front > .header > .position {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: #858f96 !important;
    text-transform: uppercase !important;
  }

  .meet-team-card > .person-data-box > .front > .body {
    font-size: 12px;
    color: #595959;
  }

  @media screen and (max-width: 576px) {
   .meet-team-card > .person-data-box > .front > .body {
     line-height: 1.2;
  }
  .slick-slide:nth-of-type(4) div div div div:nth-child(2) .front {
    justify-content: flex-end;
  }

  .slick-slide:nth-of-type(4) div div div div:nth-child(2) .body {
    padding-top: 10px;
    line-height: 1.1;
  }
  .meet-team-card-back {
    font-size: 0.6rem;
  }
  }

</style>